import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../../MainContext";
import { request } from "../../../../request";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";
import { convertToApproximateString } from "../../Inputs/convert";
import { icons } from "../../../../icons";
import CreatableSelect from "react-select/creatable";
import { CircularProgress } from "@mui/material";
import { CurrencyIcon } from "../../CurrencyIcons/CurrencyIcons";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useRef } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { IconSelector } from "./IconSelector";

// const ImageUploader: React.FC<any> = ({ handleImageChange, texts }) => {
//     const fileInputRef = useRef<HTMLInputElement>(null);

//     const handleButtonClick = () => {
//         fileInputRef.current?.click();
//     };

//     const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         handleImageChange(e);

//         // Clear input after 2 seconds
//         setTimeout(() => {
//             if (fileInputRef.current) {
//                 fileInputRef.current.value = "";
//             }
//         }, 2000);
//     };

//     return (
//         <div>
//             <button type="button" onClick={handleButtonClick} className="upload-btn">
//                 {texts.account.changeIcon}
//             </button>
//             <input type="file" ref={fileInputRef} onChange={onFileChange} accept="image/*" multiple hidden />
//         </div>
//     );
// };

const AccountList = () => {
    const { accounts: all_accounts, inactiveAccounts, darkMode, updateAccounts, updateInactiveAccounts, accountTypes, updateAccountTypes, all_currencies, texts } = useContext(MainContext);
    const [accounts_by_type, set_accounts_by_type] = useState<Object>({});
    const [editing, setEditing] = useState(false);
    const [openFormIndex, setOpenFormIndex] = useState<number | null>(null);
    const [newCurrency, setNewCurrency] = useState({
        currency_name: "",
        value: 0,
        avg: 0,
    });

    const [nameEditing, setNameEditing] = useState(false);
    const [newNameValue, setNewNameValue] = useState("");
    const [selectingIcon, setSelectingIcon] = useState(null);

    useEffect(() => {
        const new_accounts: any = {};
        all_accounts.map((acc: any) => {
            if (new_accounts[acc.type]) {
                new_accounts[acc.type].push(acc);
            } else {
                new_accounts[acc.type] = [acc];
            }
        });

        set_accounts_by_type(new_accounts);
    }, [all_accounts, accountTypes]);

    console.log("types", accountTypes);

    const updateAccountTypePriority = async (increment: -1 | 1, accountTypeName: string) => {
        if (increment === 1) {
            const type_obj_index = accountTypes.sort((a: any, b: any) => b.priority - a.priority).findIndex((acc: any) => acc.name === accountTypeName);
            const sortedAccountType = accountTypes.sort((a: any, b: any) => b.priority - a.priority);
            const previous_type_obj = sortedAccountType[type_obj_index - 1];

            if (previous_type_obj && sortedAccountType[type_obj_index]) {
                await request.patch("/account/type/" + sortedAccountType[type_obj_index]._id.toString(), {
                    priority: previous_type_obj.priority + 1,
                });
                updateAccountTypes();
            }
        } else if (increment === -1) {
            const type_obj_index = accountTypes.sort((a: any, b: any) => b.priority - a.priority).findIndex((acc: any) => acc.name === accountTypeName);
            const sortedAccountType = accountTypes.sort((a: any, b: any) => b.priority - a.priority);
            const previous_type_obj = sortedAccountType[type_obj_index + 1];
            console.log(sortedAccountType);
            console.log(previous_type_obj);

            if (previous_type_obj && sortedAccountType[type_obj_index]) {
                await request.patch("/account/type/" + sortedAccountType[type_obj_index]._id.toString(), {
                    priority: previous_type_obj.priority - 1,
                });
                updateAccountTypes();
            }
        }
    };

    const addCurrency = async (accountId: any) => {
        const formData = new FormData();

        formData.append("currencies", JSON.stringify([newCurrency]));

        try {
            const response = await request.post(`/account/edit/${accountId.toString()}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            updateAccounts();
            setOpenFormIndex(null);
        } catch (error) {
            console.log(error);
        }
    };

    const changeType = async (type: any, accountId: any) => {
        const formData = new FormData();

        formData.append("type", type.label);

        try {
            const response = await request.post(`/account/edit/${accountId.toString()}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            updateAccounts();
            setOpenFormIndex(null);
        } catch (error) {
            console.log(error);
        }
    };

    const changeName = async (name: any, accountId: any) => {
        const formData = new FormData();

        formData.append("name", name);

        try {
            const response = await request.post(`/account/edit/${accountId.toString()}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            await updateAccounts();
            setOpenFormIndex(null);
        } catch (error) {
            console.log(error);
        }
    };

    const changeAccountStatus = async (accountId: any) => {
        try {
            const response = await request.post(`/account/change-status/${accountId}`);

            updateAccounts();
            setOpenFormIndex(null);
        } catch (error) {
            console.log(error);
        }
    };

    const updateAccountPriority = async (increment: -1 | 1, account: any) => {
        if (increment === 1) {
            const formData = new FormData();
            //@ts-ignore
            const sortedAccountsTypes = accounts_by_type[account.type].sort((a: any, b: any) => b.priority - a.priority);
            //@ts-ignore
            const previous_type_index = sortedAccountsTypes.findIndex((e) => e._id.toString() === account._id.toString()) - 1;
            //@ts-ignore
            formData.append("priority", (parseInt(sortedAccountsTypes[previous_type_index === -1 ? 0 : previous_type_index].priority || 0) + 1).toString());

            try {
                const response = await request.post(`/account/edit/${account._id.toString()}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                updateAccounts();
            } catch (error) {
                console.log(error);
            }
        } else if (increment === -1) {
            const formData = new FormData();
            //@ts-ignore
            const sortedAccountsTypes = accounts_by_type[account.type].sort((a: any, b: any) => b.priority - a.priority);
            //@ts-ignore
            const previous_type_index = sortedAccountsTypes.findIndex((e) => e._id.toString() === account._id.toString()) + 1;

            //@ts-ignore
            formData.append("priority", (parseInt(sortedAccountsTypes[previous_type_index].priority) - 1).toString());

            try {
                const response = await request.post(`/account/edit/${account._id.toString()}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                updateAccounts();
            } catch (error) {
                console.log(error);
            }
        }
    };
    function chunkArray<T>(arr: T[], chunkCount: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < chunkCount; i++) {
            result.push([]);
        }
        arr.forEach((a, i) => {
            result[i % chunkCount].push(a);
        });
        // const perChunk = Math.ceil(arr.length / chunkCount);
        // for (let i = 0; i < chunkCount; i++) {
        //     result.push(arr.slice(i * perChunk, (i + 1) * perChunk));
        // }
        return result;
    }

    const createableSelectStyles = {
        control: (base: any) => ({
            ...base,
            borderColor: "gray",
            borderRadius: "0.375rem",
            padding: "0.375rem",
            boxShadow: "none",
            "&:hover": {
                borderColor: "blue",
            },
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isSelected ? "blue" : state.isFocused ? "lightgray" : "white",
            color: state.isSelected ? "white" : "black",
            "&:hover": {
                backgroundColor: "lightblue",
            },
        }),
        menu: (base: any) => ({
            ...base,
            marginTop: 0,
            borderRadius: "0.375rem",
        }),
        placeholder: (base: any) => ({
            ...base,
            color: "gray",
            fontSize: "0.875rem",
        }),
    };

    const addNewAccountType = async (type: any) => {
        console.log(type);
        if (type !== null) {
            try {
                await request.post("/account/type", {
                    name: type,
                    priority: 1,
                });
                updateAccountTypes();
            } catch (error) {
                console.log(error);
            }
        }
    };

    const options = accountTypes.map((option: any) => ({
        value: option.name,
        label: option.name,
    }));

    //@ts-ignore
    const sortedEntries = Object.entries(accounts_by_type).sort(([a], [b]) => {
        const priorityA = accountTypes.find((type: any) => type.name === a)?.priority ?? 999;
        const priorityB = accountTypes.find((type: any) => type.name === b)?.priority ?? 999;
        return priorityB - priorityA;
    });
    const columns = chunkArray(sortedEntries, 3); // Change `3` to however many columns you want
    return (
        <div className="account-list">
            {selectingIcon && (
                <div style={{ zIndex: "100", left: "0", top: "0", backgroundColor: "rgba(0,0,0,0.7)", position: "fixed", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ position: "relative", backgroundColor: "white", borderRadius: "10px", width: "500px", maxWidth: "90%", minHeight: "200px" }}>
                        <IconSelector closeModal={() => setSelectingIcon(null)} account={selectingIcon} />
                        <div
                            onClick={() => setSelectingIcon(null)}
                            style={{
                                cursor: "pointer",
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                height: "30px",
                                width: "30px",
                                backgroundColor: "black",
                                color: "white",
                                borderRadius: "100%",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <p>X</p>
                        </div>
                    </div>
                </div>
            )}
            <div className="layout-content-container">
                <div className="header">
                    <p className="title" style={{ color: darkMode ? "white" : "#111418" }}>
                        {texts.account.myAccounts}
                        {(!all_accounts || all_accounts.length === 0) && (
                            <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginLeft: "10px" }}>
                                <CircularProgress color="inherit" />
                            </Box>
                        )}
                    </p>
                    <div className="edit-switch">
                        <p>{texts.account.editing}: </p>
                        <div className="switch" data-isOn={editing} onClick={() => setEditing(!editing)}>
                            <motion.div className="handle" layout transition={{ type: "spring", stiffness: 700, damping: 30 }} />
                        </div>
                    </div>
                </div>
                <div className="list-columns" style={{ display: "flex", gap: "20px" }}>
                    {columns.map((column, colIndex) => (
                        <div key={colIndex} className="list-column" style={{ flex: 1 }}>
                            {column.map(([account_type, accounts]) => (
                                <div key={account_type} className="accounts-block">
                                    <div className="divider">
                                        <div className="names">
                                            <p>{account_type}</p>
                                            {editing ? (
                                                <div className="arrow-btns">
                                                    <div className="arrow-btn" onClick={() => updateAccountTypePriority(1, account_type)}>
                                                        ↑
                                                    </div>
                                                    <div className="arrow-btn" onClick={() => updateAccountTypePriority(-1, account_type)}>
                                                        ↓
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                        <hr />
                                    </div>
                                    <div className="list-container">
                                        {accounts
                                            .sort((a: any, b: any) => b.priority - a.priority)
                                            .map((account: any, index: number) => (
                                                <>
                                                    <div
                                                        key={account._id}
                                                        className={`account-card ${!account.active ? "inactive" : ""} ${darkMode ? "dark" : ""}`}
                                                        style={{
                                                            display: "flex",
                                                            flexWrap: editing ? "wrap" : undefined,
                                                            alignItems: editing ? "center" : undefined,
                                                            justifyContent: editing ? "center" : undefined,
                                                            flexDirection: editing ? "column" : undefined,
                                                            width: editing ? "450px" : "",
                                                        }}
                                                    >
                                                        <div className="name-and-icon">
                                                            <img className="account-icon" src={account.icon ? `${process.env.REACT_APP_IMG_SRC}/api/icons/${account.icon}` : icons["CANCEL"]} alt="" />
                                                            {editing && nameEditing === account._id ? (
                                                                <>
                                                                    <input type="text" value={newNameValue} onChange={(e) => setNewNameValue(e.target.value)} />
                                                                    <SaveIcon
                                                                        onClick={() => {
                                                                            changeName(newNameValue, account._id).then(() => {
                                                                                setNameEditing(false);
                                                                            });
                                                                        }}
                                                                        fontSize="large"
                                                                        style={{ color: "white", border: "1px solid white", borderRadius: "5px", padding: "5px", margin: "0px 5px" }}
                                                                    />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <p className="account-name" style={{ color: darkMode ? "white" : "#111418" }}>
                                                                        {account.name}
                                                                    </p>
                                                                    {editing && (
                                                                        <EditIcon
                                                                            onClick={() => {
                                                                                setNameEditing(account._id);
                                                                                setNewNameValue(account.name);
                                                                            }}
                                                                            fontSize="large"
                                                                            style={{ color: "white", border: "1px solid white", borderRadius: "5px", padding: "5px", margin: "0px 5px" }}
                                                                        />
                                                                    )}
                                                                </>
                                                            )}

                                                            {editing && (
                                                                <InfoOutlinedIcon
                                                                    sx={{ marginRight: "20px", cursor: "pointer", color: "white" }}
                                                                    onClick={async () => {
                                                                        // Step 1: Ask user to pick a date
                                                                        const { value: selectedDate } = await Swal.fire({
                                                                            title: "Select a date",
                                                                            input: "date",
                                                                            inputAttributes: {
                                                                                required: "true",
                                                                            },
                                                                            confirmButtonText: "Submit",
                                                                            showCancelButton: true,
                                                                        });

                                                                        if (!selectedDate) return;

                                                                        // Step 2: Show loading state
                                                                        Swal.fire({
                                                                            title: "Loading...",
                                                                            text: "Fetching data for the selected date...",
                                                                            allowOutsideClick: false,
                                                                            didOpen: () => {
                                                                                Swal.showLoading();
                                                                            },
                                                                        });

                                                                        try {
                                                                            // Step 3: Send request to the server
                                                                            const res = await request.post("/account/get-account-info", { date: selectedDate, _id: account._id });
                                                                            // Step 4: Convert response text into <ul> list
                                                                            const items = res.data.message
                                                                                .split("\n")
                                                                                .filter((line: string) => line.trim() !== "")
                                                                                .map((line: string) => `<li>${line}</li>`)
                                                                                .join("");

                                                                            const htmlList = `<ul style="text-align:left; list-style:disc; margin-left:20px;">${items}</ul>`;

                                                                            // Step 5: Show result
                                                                            Swal.fire({
                                                                                title: "Result",
                                                                                html: htmlList,
                                                                                icon: "info",
                                                                                width: 600,
                                                                            });
                                                                        } catch (err: any) {
                                                                            Swal.fire({
                                                                                title: "Error",
                                                                                text: err.response?.data?.message || "Failed to fetch data.",
                                                                                icon: "error",
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                        {editing && (
                                                            <div className="add-btn-wrapper">
                                                                <button style={{ backgroundColor: "red" }} className="add-btn" onClick={() => changeAccountStatus(account._id)}>
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <div className="currency-list">
                                                                {account.currencies.map((curr: any) => {
                                                                    let timer1: any;
                                                                    const start1 = () => (timer1 = setTimeout(onLongPress1, 600));
                                                                    const stop1 = () => clearTimeout(timer1);
                                                                    const onLongPress1 = () => {
                                                                        if (window.localStorage.login !== "root") return;
                                                                        Swal.fire({
                                                                            title: `Edit value of ${account.name} ${curr.currency_name}`,
                                                                            input: "number",
                                                                            inputLabel: "Value",
                                                                            showCancelButton: true,
                                                                            inputValue: curr.value,
                                                                            preConfirm: (value) => {
                                                                                // this runs like a synchronous callback before closing the dialog
                                                                                if (!value || isNaN(value)) {
                                                                                    Swal.showValidationMessage("Please enter a valid number");
                                                                                    return false; // prevent closing
                                                                                }
                                                                                return Number(value); // this value will be returned in the then()
                                                                            },
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                console.log("Number from user:", result.value);
                                                                                request
                                                                                    .post("/account/edit-value", {
                                                                                        id: account._id,
                                                                                        value: result.value,
                                                                                        currency_name: curr.currency_name,
                                                                                    })
                                                                                    .then(() => {
                                                                                        updateAccounts();
                                                                                        Swal.fire({
                                                                                            icon: "success",
                                                                                        });
                                                                                    });
                                                                                // use the number here
                                                                            }
                                                                        });
                                                                    };
                                                                    let timer2: any;
                                                                    const start2 = () => (timer2 = setTimeout(onLongPress2, 600));
                                                                    const stop2 = () => clearTimeout(timer2);
                                                                    const onLongPress2 = () => {
                                                                        if (window.localStorage.login !== "root") return;
                                                                        Swal.fire({
                                                                            title: `Edit avg of ${account.name} ${curr.currency_name}`,
                                                                            input: "number",
                                                                            inputLabel: "Value",
                                                                            showCancelButton: true,
                                                                            inputValue: curr.avg,
                                                                            preConfirm: (value) => {
                                                                                // this runs like a synchronous callback before closing the dialog
                                                                                if (!value || isNaN(value)) {
                                                                                    Swal.showValidationMessage("Please enter a valid number");
                                                                                    return false; // prevent closing
                                                                                }
                                                                                return Number(value); // this value will be returned in the then()
                                                                            },
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                console.log("Number from user:", result.value);
                                                                                request
                                                                                    .post("/account/edit-avg", {
                                                                                        id: account._id,
                                                                                        avg: result.value,
                                                                                        currency_name: curr.currency_name,
                                                                                    })
                                                                                    .then(() => {
                                                                                        updateAccounts();
                                                                                        Swal.fire({
                                                                                            icon: "success",
                                                                                        });
                                                                                    });
                                                                                // use the number here
                                                                            }
                                                                        });
                                                                    };

                                                                    return (
                                                                        <>
                                                                            <div key={curr.currency_id} className="currency-box">
                                                                                <div style={{ width: editing ? "180px" : "" }} className="values">
                                                                                    <p onDoubleClick={onLongPress1} onTouchStart={start1} onTouchEnd={stop1} onMouseDown={start1} onMouseUp={stop1} className="value">
                                                                                        {convertToApproximateString(curr.value) || 0}
                                                                                    </p>
                                                                                    {curr.currency_name !== "AMD" && (
                                                                                        <p onDoubleClick={onLongPress2} onTouchStart={start2} onTouchEnd={stop2} onMouseDown={start2} onMouseUp={stop2} className="avg">
                                                                                            {convertToApproximateString(curr.avg) || 0}
                                                                                        </p>
                                                                                    )}
                                                                                </div>
                                                                                <CurrencyIcon className="icon" currency_name={curr.currency_name} />
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })}
                                                            </div>
                                                            {editing && (
                                                                <div className="add-btn-wrapper">
                                                                    <button className="add-btn" onClick={() => setOpenFormIndex(openFormIndex === account._id ? null : account._id)}>
                                                                        {texts.account.addCurrency}
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {openFormIndex === account._id && (
                                                                <div className="add-currency-form">
                                                                    <select
                                                                        value={newCurrency.currency_name}
                                                                        onChange={(e) =>
                                                                            setNewCurrency({
                                                                                ...newCurrency,
                                                                                currency_name: e.target.value,
                                                                            })
                                                                        }
                                                                    >
                                                                        <option value="">Select Currency</option>
                                                                        {all_currencies
                                                                            .filter((e: any) => !account.currencies.find((c: any) => c.currency_name === e))
                                                                            .map((curr: any) => {
                                                                                return <option value={curr}>{curr}</option>;
                                                                            })}
                                                                    </select>
                                                                    <p style={{ color: "white" }}>Value</p>
                                                                    <input type="text" placeholder="Value" value={newCurrency.value} onChange={(e) => setNewCurrency({ ...newCurrency, value: Number(e.target.value) })} />
                                                                    <p style={{ color: "white" }}>Average</p>
                                                                    <input type="text" placeholder="Avg" value={newCurrency.avg} onChange={(e) => setNewCurrency({ ...newCurrency, avg: Number(e.target.value) })} />
                                                                    <button className="create-btn" onClick={() => addCurrency(account._id)}>
                                                                        Create
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* {isOn && (
															<div className="account-actions">
																<button onClick={() => deactivateAcc(account._id)}>Deactivate</button>
																<button onClick={() => deleteAcc(account._id)}>Delete</button>
																<button onClick={() => openEditorAndSetId(account._id)}>Edit</button>
															</div>
														)} */}
                                                        <br />
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            {editing && (
                                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                                    {/* <ImageUploader handleImageChange={(e: any) => handleImageChange(e, account)} texts={texts} /> */}
                                                                    {/* <button onClick={() => setSelectingIcon(account)}>Change icon </button> */}
                                                                    <button type="button" onClick={() => setSelectingIcon(account)} className="upload-btn">
                                                                        {texts.account.changeIcon}
                                                                    </button>
                                                                    <div className="arrow-btns">
                                                                        <div className="arrow-btn" onClick={() => updateAccountPriority(1, account)}>
                                                                            ↑
                                                                        </div>
                                                                        <div className="arrow-btn" onClick={() => updateAccountPriority(-1, account)}>
                                                                            ↓
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {editing && (
                                                                <label className="flex flex-col min-w-40 flex-1" style={{ marginTop: "21px" }}>
                                                                    <CreatableSelect
                                                                        isClearable
                                                                        options={options}
                                                                        onChange={(e) => (e !== null ? changeType(e, account._id) : "")}
                                                                        value={account.type ? { label: account.type } : ""}
                                                                        onCreateOption={(e) => addNewAccountType(e)}
                                                                        styles={createableSelectStyles}
                                                                        placeholder="Account Type"
                                                                        name="account-type"
                                                                    />
                                                                </label>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                    </div>{" "}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="list">
                    {Object.entries(accounts_by_type)
                        .sort(([a], [b]) => {
                            const priorityA = accountTypes.find((type: any) => type.name === a)?.priority ?? 999;
                            const priorityB = accountTypes.find((type: any) => type.name === b)?.priority ?? 999;
                            return priorityB - priorityA;
                        })
                        .map(([account_type, accounts]) => (
                            <div key={account_type} className="accounts-block"></div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default AccountList;
